import axios from 'axios'
import {useAdminOptionsStore} from '@/stores/AdminOptionsStore'
import Snackbar from '@/components/Snackbar'
import Alert from '@/components/Alert'
import {mapWritableState} from 'pinia'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'
    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'
    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}
/**
 * This one is common for admin options and categories options
 */
export default {

    data() {
        return {
            progressForIndividualOption: false,
            showProgressBar: false,
            showTlsProgressBar: false,
            isTlsApplicable: false,
        }
    },
    components: {Snackbar, Alert},
    computed: {
        ...mapWritableState(useAdminOptionsStore, {
            adminOptions: 'adminOptions',
            tlsFilter: 'tlsFilter',
        })
    },

    mounted() {
        this.loadAdminOptionsToStoreIfNotLoadedAlready()
        // this.adminGetStatusForTlsFilterAndSetInStore(); // TODO: this and all the associated functions should be removed as we are now doing it in a different way.
    },
    methods: {

        async toggleAdminOption(option) {

            let self = this
            self.showProgressBar = true
            self.progressForIndividualOption = option.key
            let outputOfAdminOptionStatusToggle = await self.toggleAdminOptionStatus(option.key, option.value.status)
            self.progressForIndividualOption = false
            self.showProgressBar = false

            self.$refs.snackbar.showSnackbar(option.value.title + ' (' + (option.value.status ? 'enable' : 'disable') + '): ' + outputOfAdminOptionStatusToggle.data)

        },

        async adminGetStatusForAllAdminOptions() {

            try {

                const adminRequest = await axios.get('admin_options.php', {params: {'operation': 'get_status_for_all_admin_options'}})

                if (!adminRequest.data.status) {
                    // TODO: Handle else
                } else {
                    return adminRequest.data
                }

            } catch (requestError) {
                throw requestError
            }

        },

        async adminGetStatusForTlsFilter() {

            let self = this

            try {

                return await axios.get('admin_options.php', {
                    params: {
                        'operation': 'check_tls_filter'
                    }
                })

            } catch (requestError) {
                throw requestError
            }

        },

        async adminGetStatusForTlsFilterAndSetInStore() {

            let self = this

            const adminOptionsStore = useAdminOptionsStore()
            self.showTlsProgressBar = true

            try {

                const getTlsFilterStatusResponse = await self.adminGetStatusForTlsFilter()

                if (getTlsFilterStatusResponse) {

                    if (getTlsFilterStatusResponse?.data?.status) {
                        self.isTlsApplicable = true
                        adminOptionsStore.tlsFilter = getTlsFilterStatusResponse.data.data
                    } else {

                        let errorText = getTlsFilterStatusResponse.data.error

                        if (typeof errorText !== 'string') {
                            errorText = 'Sorry! Error occurred, the status for tls filter could not be retrieved. Please try again in sometime (I).'
                        }

                        // self.$refs.snackbar.showSnackbar(errorText, 'error');

                    }

                } else {
                    self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! Error occurred, the status for tls filter could not be retrieved. Please try again in sometime (II).'), 'error')
                }

            } catch (requestError) {
                self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! Error occurred, the status for tls filter could not be retrieved. Please try again in sometime (III).'), 'error')
            } finally {
                self.showTlsProgressBar = false
            }

        },

        async adminGetStatusForAllAdminOptionsAndSetInStore() {

            let self = this
            const adminOptionsStore = useAdminOptionsStore()

            try {

                const adminRequest = await self.adminGetStatusForAllAdminOptions()

                if (adminRequest) {

                    let adminRequestData

                    if (adminRequest.data.length > 0) {

                        if (typeof adminRequest.data === 'string') {
                            adminRequestData = JSON.parse(adminRequest.data)
                        } else {
                            adminRequestData = adminRequest.data
                        }

                        adminRequestData = Object.entries(adminRequestData)

                        for (const [key, value] of adminRequestData) {
                            adminOptionsStore.adminOptions.map((item) => {
                                item.key === key ? item.value.status = value : null
                            })
                        }

                    }

                } else {
                    // todo: handle this
                }

            } catch (requestError) {
                throw requestError
            }

        },

        async loadAdminOptionsToStoreIfNotLoadedAlready() {

            let self = this

            self.showProgressBar = true
            const adminOptionsStore = useAdminOptionsStore()

            try {
                // TODO: Whenever we have switch item here, test for that as well.
                if (adminOptionsStore.isItemNotLoaded('safesearch')) {
                    return await self.adminGetStatusForAllAdminOptionsAndSetInStore()
                }
            } catch (requestError) {
                // FIXME: REMOVE THIS
                console.log(requestError)
            } finally {
                self.showProgressBar = false
            }

            return false

        },

        async toggleAdminOptionStatus(optionName, desiredStatus) {

            try {

                let adminRequest = await axios.get('admin_options.php', {
                    params: {
                        'operation': 'toggle_admin_options_status',
                        'optionName': optionName,
                        'desiredStatus': desiredStatus
                    }
                })

                return adminRequest.data

            } catch (requestError) {
                throw requestError
            }

        },

        showCircularLoadingForSwitch(option) {

            let self = this

            if (this.showProgressBar) {

                let colour = 'primary'

                if (self.progressForIndividualOption) {
                    return (self.progressForIndividualOption === option.key) ? colour : false
                } else {
                    return colour
                }

            }

            return false
        },

        showCircularLoadingForTlsFilter() {

            if (this.showTlsProgressBar) {
                return 'primary'
            }

            return false

        },

        async updateTlsFilter(switchValue) {

            let self = this

            self.showTlsProgressBar = true

            let response = await axios.get('admin_options.php', {
                params: {
                    'operation': 'update_tls_filter',
                    'tlsFilterSwitchValue': switchValue ? 'on' : 'off'
                }
            })

            self.showTlsProgressBar = false

            if (response && response.hasOwnProperty('data') && typeof response.data === 'object') {

                response = response.data

                if (response && response.hasOwnProperty('status') && !response.status) {

                    (response?.error) ?
                        self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! update failed!'), 'error') :
                        self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! unknown error occurred'), 'error')

                    self.$nextTick(() => self.tlsFilter = !switchValue) // nextTick is important here!

                } else {
                    self.$refs.snackbar.showSnackbar(response.data)
                }

            }

        }

    },

}
